import {
  NotaComercialApiResponse,
  GETInstrumentosFilterParams,
  CadastroNotaComercialApiRequest,
  SolicitarLiquidacaoRequest,
  HistoricoResponse,
  DocumentRequest,
  Document,
  CadastroInstrumentoFinanceiroApiRequest,
  CommandResultTyped,
} from 'common/genericTypes';
import { Dispatch } from 'redux';
import {
  GETNotaComercialDetalhes,
  GETNotasComerciais,
  POSTNotaComercial,
  PUTNotaComercial,
  POSTInterOpNotaComercial,
  POSTEnviarLiquidacao,
  GETHistoricoNotaComercial,
  POSTConfirmarLiquidacaoNotaComercial,
  PUTUploadDoc as PUTUploadDocNotaComercial,
  DELETEUploadDoc as DELETEUploadDocNotaComercial,
  GETNotaComercialByInstrumentoId,
  POSTTermoConstitutivo,
  PUTNotaComercialAditamento,
  PUTEditarNotaComercial,
  GETNotasComerciaisByEmissorCnpj,
  GETAditamentoNotaComercial,
  PUTAditamentoNotaComercial,
} from 'requests/notaComercial';
import { UploadDocResponse } from '../models/uploadDocResponse';
import { typedAction } from 'store/modules/base';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export interface NotaComercialApiState {
  getNotaComercialDetalhes(dispatch: Dispatch, id: string, stackRequest?: boolean): Promise<NotaComercialApiResponse>;
  getNotasComerciais(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<NotaComercialApiResponse>>;
  getNotaComercialByInstrumentoId(
    dispatch: Dispatch,
    instrumentoId: string,
    stackRequest?: boolean
  ): Promise<NotaComercialApiResponse>;
  postNotaComercial(
    dispatch: Dispatch,
    NotaComercial: CadastroNotaComercialApiRequest,
    stackRequest?: boolean
  ): Promise<NotaComercialApiResponse>;
  putNotaComercial(
    dispatch: Dispatch,
    NotaComercialId: string,
    NotaComercial: CadastroNotaComercialApiRequest,
    stackRequest?: boolean
  ): Promise<NotaComercialApiResponse>;
  putNotaComercialAditamento(
    dispatch: Dispatch,
    NotaComercialId: string,
    NotaComercial: CadastroNotaComercialApiRequest,
    date: string,
    document: File,
    stackRequest?: boolean
  ): Promise<string>;
  putEditarNotaComercial(
    dispatch: Dispatch,
    NotaComercialId: string,
    NotaComercial: CadastroNotaComercialApiRequest,
    justificativa: string,
    document?: File,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<string>>;
  putUploadDoc(
    dispatch: Dispatch,
    NotaComercialId: string,
    emissionType: string,
    file: File,
    stackRequest?: boolean
  ): Promise<Array<UploadDocResponse>>;
  deleteUploadDoc(
    dispatch: Dispatch,
    NotaComercialId: string,
    NotaComercialDocumentId: string,
    stackRequest?: boolean
  ): Promise<unknown>;
  postTermoConstitutivo(
    dispatch: Dispatch,
    instrumentoFinanceiro: CadastroInstrumentoFinanceiroApiRequest,
    stackRequest?: boolean
  ): Promise<Document>;
  postInterOpNotaComercial(
    dispatch: Dispatch,
    NotaComercial: CadastroNotaComercialApiRequest,
    stackRequest?: boolean
  ): Promise<NotaComercialApiResponse>;
  postEnviarLiquidacao(
    dispatch: Dispatch,
    NotaComercialId: string,
    NotaComercialSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
    stackRequest?: boolean
  ): Promise<NotaComercialApiResponse>;
  postConfirmarLiquidacaoNotaComercial(
    dispatch: Dispatch,
    NotaComercialId: string,
    precoUnitarioLiquidacao:number,
    stackRequest?: boolean
  ): Promise<NotaComercialApiResponse>;
  getHistoricoNotaComercial(
    dispatch: Dispatch,
    NotaComercialId: string,
    stackRequest?: boolean
  ): Promise<Array<HistoricoResponse>>;
  getNotasComerciaisByEmissorCnpj(
    dispatch: Dispatch,
    cnpjEmissor?: string,
    stackRequest?: boolean
  ): Promise<Array<{codigo: string}>>;
  getAditamentoNotaComercial(
    dispatch: Dispatch,
    aditamentoId: string,
    stackRequest?: boolean
  ): Promise<AditamentoRevisionData>;
  putAditamentoNotaComercial(
    dispatch: Dispatch,
    aditamentoId: string,
    diferenca: AditamentoDiferenca[],
    stackRequest?: boolean
  ): Promise<Array<AditamentoDiferenca>>;
}

export const NotaComercialApiInicialState: NotaComercialApiState = {
  getNotaComercialDetalhes: GETNotaComercialDetalhes,
  getNotasComerciais: GETNotasComerciais,
  getNotaComercialByInstrumentoId: GETNotaComercialByInstrumentoId,
  postNotaComercial: POSTNotaComercial,
  putNotaComercial: PUTNotaComercial,
  putNotaComercialAditamento: PUTNotaComercialAditamento,
  putEditarNotaComercial: PUTEditarNotaComercial,
  putUploadDoc: PUTUploadDocNotaComercial,
  deleteUploadDoc: DELETEUploadDocNotaComercial,
  postTermoConstitutivo: POSTTermoConstitutivo,
  postInterOpNotaComercial: POSTInterOpNotaComercial,
  postEnviarLiquidacao: POSTEnviarLiquidacao,
  postConfirmarLiquidacaoNotaComercial: POSTConfirmarLiquidacaoNotaComercial,
  getHistoricoNotaComercial: GETHistoricoNotaComercial,
  getNotasComerciaisByEmissorCnpj: GETNotasComerciaisByEmissorCnpj,
  getAditamentoNotaComercial: GETAditamentoNotaComercial,
  putAditamentoNotaComercial: PUTAditamentoNotaComercial,
};

enum NotaComercialApiActionType {
  Update = 'notaComercialApi/UPDATE',
  Reset = 'notaComercialApi/RESET',
}

export const updateNotaComercialApi = (state: NotaComercialApiState) => {
  return typedAction(NotaComercialApiActionType.Update, state);
};

export const resetNotaComercialApi = () => {
  return typedAction(NotaComercialApiActionType.Reset);
};

type NotaComercialApiAction = ReturnType<typeof updateNotaComercialApi | typeof resetNotaComercialApi>;

export function notaComercialApiReducer(
  state: NotaComercialApiState = NotaComercialApiInicialState,
  action: NotaComercialApiAction
): NotaComercialApiState {
  switch (action.type) {
    case NotaComercialApiActionType.Update:
      return { ...action.payload };
    case NotaComercialApiActionType.Reset:
      return { ...NotaComercialApiInicialState };
    default:
      return state;
  }
}
